import debounce from 'lodash/debounce'

const SELECTORS = Selectors({
  invoiceForm: 'booking-invoice-form--online',
  existingCardField: 'BookingInvoiceForm_BookingInvoiceForm_UseDefaultStripeCard',
  newCardFields: 'new-card-fields',
  couponHolder: 'booking-invoice-coupon-holder',
  stripeCardElement: 'card-element',
  paypalElement: 'paypal-payment-container'
})

const $form = document.querySelector(SELECTORS.asClass('invoiceForm'))
const $existingCardField = document.querySelector(SELECTORS.asId('existingCardField'))
const $newCardFields = document.querySelector(SELECTORS.asClass('newCardFields'))
const $cardElement = document.getElementById(SELECTORS.stripeCardElement)
const $paypalElement = document.getElementById(SELECTORS.paypalElement)
const $submitButton = document.querySelector(`${SELECTORS.asClass('invoiceForm')} [type=submit]`)
const $couponFieldHolder = document.querySelector(SELECTORS.asClass('couponHolder'))
const $invoiceField = document.querySelector('[type=hidden][name=InvoiceID]')

const state = {
  stripe: null,
  stripeCard: null,
  paymentRequest: null,
  paypal: null,
  amount: null,
  amountAsCents: null
}

const fn = {
  init: () => {
    if ($form) {
      state.stripe = window.Stripe($form.dataset.stripePubKey)
      state.stripeElements = state.stripe.elements()

      if ($cardElement) {
        fn.setupStripeCard()
      }

      if ($paypalElement) {
        state.paypal = window.paypal
      }

      $.ajax({
        type: 'post',
        dataType: 'json',
        url: `${$form.dataset.controllerUrl}fetchinvoicedata`,
        data: {
          invoiceId: $invoiceField.value
        },
        success: (resp) => {
          state.amount = resp.amount
          state.amountAsCents = resp.amount_as_cents
          fn.setupPaypal()
          fn.setupApplePay()
        }
      })

      fn.bindEvents()
    }
  },

  bindEvents: () => {
    $form.addEventListener('submit', fn.handleSubmit)

    if ($existingCardField) {
      $existingCardField.addEventListener('change', (e) => {
        if (e.target.checked) {
          $newCardFields.style.display = 'none'
        } else {
          $newCardFields.style.display = 'block'
        }
      })
    }

    if ($couponFieldHolder) {
      const $field = $couponFieldHolder.querySelector('[type=text]')
      const $button = $couponFieldHolder.querySelector('button[type=button]')

      $field.addEventListener('keydown', (e) => {
        if (e.keyCode === 13) {
          e.preventDefault()

          if (e.target.value !== '') {
            fn.checkCoupon(e.target.value)
          }
        }
      })

      $button.addEventListener('click', () => {
        if ($field.value === '') {
          $field.focus()

          return false
        }

        fn.checkCoupon($field.value)
      })
    }
  },

  checkCoupon: (code) => {
    $.ajax({
        type: 'post',
        dataType: 'json',
        url: `${$form.dataset.controllerUrl}handlecouponcode`,
        data: {
          invoiceId: $invoiceField.value,
          coupon: code
        },
        success: (resp) => {
          const $message = $form.querySelector('.booking-invoice-coupon-holder__message')

          if (resp.success) {
            state.amount = resp.updated_amount
            state.amountAsCents = resp.updated_amount_as_cents

            if (state.paymentRequest) {
              state.paymentRequest.update({
                total: {
                  label: 'The Center Booking Space Request',
                  amount: state.amountAsCents
                }
              })
            }

            $form.querySelector('.booking-invoice-total__amount').innerHTML = resp.updated_display_amount

            let $couponInput = $form.querySelector('[type=hidden][name=CouponID]')

            if (!$couponInput) {
              $couponInput = document.createElement('input')
              $couponInput.setAttribute('type', 'hidden')
              $couponInput.setAttribute('name', 'CouponID')
              $form.appendChild($couponInput)
            }

            $couponInput.setAttribute('value', resp.coupon_id)

            $message.innerHTML = resp.message
            $message.classList.remove('is-error')
            $message.style.display = 'block'
          } else {
            state.amount = resp.original_amount
            $form.querySelector('.booking-invoice-total__amount').innerHTML = resp.original_display_amount

            let $couponInput = $form.querySelector('[type=hidden][name=CouponID]')

            if ($couponInput) {
              $couponInput.remove()
            }

            $message.innerHTML = resp.message
            $message.classList.add('is-error')
            $message.style.display = 'block'
          }
        }
    })
  },

  setupStripeCard: () => {
    const style = {
      base: {
        fontSize: '16px',
        fontFamily: 'Open Sans, sans-serif',
        color: '#2c2c2c',
        fontSmoothing: 'antialiased',
        textTransform: 'uppercase',
        '::placeholder': {
          color: '#b4b4b4'
        }
      },
      invalid: {
        color: '#b9112a'
      }
    }

    const card = state.stripe.elements().create('card', { style })
    card.mount(SELECTORS.asId('stripeCardElement'))
    state.stripeCard = card

    card.addEventListener('change', ({error}) => {
      const displayError = document.getElementById('card-errors')
      if (error) {
        displayError.textContent = error.message
      } else {
        displayError.textContent = ''
      }
    })

    window.addEventListener('resize', debounce(fn.updateStripeCard, 250))
    fn.updateStripeCard()
  },

  updateStripeCard: () => {
    let fontSize = '16px'

    if (window.matchMedia('(min-width: 1200px)').matches) {
      fontSize = '18px'
    }

    const style = {
      base: {
        fontSize
      }
    }

    state.stripeCard.update({ style })
  },

  setupPaypal: () => {
    state.paypal.Buttons({
      style: {
        layout: 'horizontal',
        color: 'white',
        height: 55,
        tagline: false
      },
      createOrder: function (data, actions) {
        return actions.order.create({
          purchase_units: [{
            amount: {
              value: state.amount
            }
          }]
        })
      },
      onApprove: function(data, actions) {
        return actions.order.capture().then(function (details) {
          if ($existingCardField) {
            $existingCardField.checked = false
          }

          const hiddenInput = document.createElement('input')
          hiddenInput.setAttribute('type', 'hidden')
          hiddenInput.setAttribute('name', 'paypalPayload')
          hiddenInput.setAttribute('value', JSON.stringify(details))
          $form.appendChild(hiddenInput)

          $form.forceSubmit = true
          $submitButton.disabled = false
          $submitButton.click()
          $submitButton.disabled = true
        });
      }
    }).render(SELECTORS.asId('paypalElement'))
  },

  setupApplePay: () => {
    const paymentRequest = state.stripe.paymentRequest({
      country: 'US',
      currency: 'usd',
      total: {
        label: 'The Center Booking Space Request',
        amount: state.amountAsCents
      },
      requestPayerName: true,
      requestPayerEmail: true
    })

    const paymentRequestButton = state.stripeElements.create('paymentRequestButton', {
      paymentRequest: paymentRequest,
      style: {
        paymentRequestButton: {
          height: '55px'
        }
      }
    })

    // Check the availability of the Payment Request API first
    paymentRequest.canMakePayment().then(function(result) {
      if (result && result.applePay) {
        paymentRequestButton.mount('#payment-request-button');
        state.paymentRequest = paymentRequest
      } else {
        document.getElementById('payment-request-button').style.display = 'none';
      }
    })

    paymentRequest.on('token', (e) => {
      $submitButton.disabled = true

      const hiddenInput = document.createElement('input')
      hiddenInput.setAttribute('type', 'hidden')
      hiddenInput.setAttribute('name', 'stripeApplePayToken')
      hiddenInput.setAttribute('value', e.token.id)
      $form.appendChild(hiddenInput)

      $form.submit()
    })
  },

  handleSubmit: (e) => {
    if (e.target.forceSubmit || ($existingCardField && $existingCardField.checked)) {
      return true
    }

    // Handle PayPal - if PayPal was used there should be a hidden input
    // with payload data, if so we should skip validation for Stripe and submit
    if (document.querySelector('[name=paypalPayload]')) {
      return true
    }

    e.preventDefault()

    // Handle Stripe
    $submitButton.disabled = true

    state.stripe.createToken(state.stripeCard).then((result) => {
      if (result.error) {
        const errorElement = document.getElementById('card-errors')
        errorElement.textContent = result.error.message
      } else {
        fn.stripeTokenHandler(result.token)
      }
    })

    return false
  },

  stripeTokenHandler: (token) => {
    const hiddenInput = document.createElement('input')
    hiddenInput.setAttribute('type', 'hidden')
    hiddenInput.setAttribute('name', 'stripeToken')
    hiddenInput.setAttribute('value', token.id)
    $form.appendChild(hiddenInput)

    $form.submit()
  }
}

export default {
  can: () => document.body.classList.contains('pagetype-bookingaccountpage'),
  run: fn.init
}
